import campaignAxios from './campaignAxios'

export const campaigns = () => {
  return campaignAxios.get(`/campaigns`, )
}

export const campaign = (bank,campaignId) => {
  return campaignAxios.get('/'+bank+`/campaign/${campaignId}`)
}

export const postCampaign = (bank,campaign) => {
  return campaignAxios.post('/'+bank+`/create`, campaign)
}

export const putCampaign = (bank,campaign) => {
  return campaignAxios.put('/'+bank+`/update`, campaign)
}

export const enableCampaign = (bank,campaign) => {
  return campaignAxios.put('/'+bank+`/enable`, campaign)
}

export const disableCampaign = (bank,campaign) => {
  return campaignAxios.put('/'+bank+`/disable`, campaign)
}

export const deleteCampaign = (bank,campaign) => {
  return campaignAxios.put('/'+bank+`/delete`, campaign)
}

// export const getCampaignsByCorporate = (campaign) => {
//   return campaignAxios.post(`/bycorporate`, campaign)
// }
export const getCampaignsByCorporate = (campaign) => {
  return campaignAxios.post(`/report/campaigns`, campaign)
}